import React from 'react'
import "./Home.css"
import Product from "./Product"

function Home() {
    return (
        <div className="home">
            <div className="home__container">
                <img className="home__image" src="https://images-eu.ssl-images-amazon.com/images/G/31/prime/Gateway/2021/desktop-1x._CB658860139_.jpg" alt=""/>
                <div className="home__row">
                   <Product id={1}
                            title="The Lean Startup: How Constant Innovation Creates Radically Successful Businesses"
                            price={1782.99}
                            image="https://images-na.ssl-images-amazon.com/images/I/51T-sMqSMiL._SX329_BO1,204,203,200_.jpg"
                            rating={5}
                            />
                   <Product id={2}
                            title="A Breath of Freedom: The Civil Rights Struggle, African American GIs, and Germany"
                            price={3901}
                            image="https://m.media-amazon.com/images/I/61b8EFd+hWL._AC_UY218_.jpg"
                            rating={5}/>
                </div>
                <div className="home__row">
                    <Product id={3}
                             title="Apple iPhone 11 (128GB) Black"
                             price={59900}
                             image="https://m.media-amazon.com/images/I/71i2XhHU3pL._AC_UY218_.jpg"
                             rating={4}/>
                    <Product id={4}
                             title="Apple iPhone 12 Pro Max(128GB) -Pacific Blue"
                             price={125900}
                             image="https://m.media-amazon.com/images/I/71MHTD3uL4L._AC_UY218_.jpg"
                             rating={4}/>
                    <Product id={5}
                             title="Samsung Galaxy S20 FE 5G (Cloud Navy, 8GB RAM, 128GB Storage"
                             price={47999}
                             image="https://m.media-amazon.com/images/I/81vDZyJQ-4L._AC_UY218_.jpg"
                             rating={4}/>
                </div>
                <div className="home__row">
                    <Product id={6}
                             title="Echo Dot (3rd Gen, Black) with Amazon 6A Smart Plug - Easy Set-Up"
                             price={4298}
                             image="https://images-eu.ssl-images-amazon.com/images/I/41TKVl+0Z8L._AC_SX184_.jpg"
                             rating={4}/>
                    <Product id={7}
                             title="MI Wi-Fi 1080p Full HD 360° Viewing Area Smart Security Camera, White"
                             price={2899}
                             image="https://images-na.ssl-images-amazon.com/images/I/61JM7nC4OKL._SL1500_.jpg"
                             rating={4}/>
                </div>
                <div className="home__row">
                <Product id={8}
                         title="OnePlus 108 cm (43 inches) Y Series Full HD LED Smart Android TV 43Y1 (Black) (2020 Model)"
                         price={26999}
                         image="https://images-na.ssl-images-amazon.com/images/I/71nsFlZ1aKL._SL1500_.jpg"
                         rating={4}/>
                </div>
            </div>
        </div>
    )
}

export default Home
